import React, { useEffect, useState } from "react";
import { post } from "../../Services/ApiHandler";
import { URL } from "../../Services/Constant";
import { Table } from "../../components/Table/Table";
import moment from "moment";
import useSearch from "../../components/Searchbox/useSearch";
import { view_icon } from "../../assets/imgs";

const TrainingList = () => {
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const searchVal = useSearch(search);
  const [pagination, setPagination] = useState({});
  const [open, setOpen] = useState(null);

  const fetchData = async (search) => {
    const formdata = new FormData();
    formdata.append("rows", 10);
    formdata.append("search", search ? search : "");
    formdata.append("order", "desc");
    formdata.append("page", page);

    const res = await post(URL.TRAINING_LIST, formdata);
    if (res?.status == "success") {
      setList(res?.lists ?? []);
      res?.lists?.forEach((item) => {
        const img = new Image();
        img.src = item?.alert_image;
      });
      setPagination(res?.pagination_meta);
    }
  };

  const columns = [
    {
      Header: "S.No",
      accessor: "sno",
      Cell: ({ value, row }) => {
        return <p>{(page - 1) * 10 + row.index + 1}</p>;
      },
    },
    {
      Header: "Site Name",
      accessor: "site_name",
      Cell: ({ value, row }) => {
        return <p>{value}</p>;
      },
    },
    {
      Header: "Date and Time",
      accessor: "captured_at",
      Cell: ({ value, row }) => {
        return (
          <p> {value ? moment(value).format("DD-MM-YYYY hh:mm A") : "-"}</p>
        );
      },
    },
    {
      Header: "Camera Number",
      accessor: "camera_code",
      Cell: ({ value, row }) => {
        return <p>{value}</p>;
      },
    },
    {
      Header: "Camera Name",
      accessor: "camera_name",
      Cell: ({ value, row }) => {
        return <p>{value}</p>;
      },
    },

    {
      Header: "Alert Type",
      accessor: "alert_type",
      Cell: ({ value, row }) => {
        return <p>{value}</p>;
      },
    },
    {
      Header: "Severity",
      accessor: "severity",
      Cell: ({ value, row }) => {
        return <p className="d-flex ac-jc">{value}</p>;
      },
    },
    {
      Header: "Alert Image",
      accessor: "alert_image",
      Cell: ({ value, row }) => {
        return (
          <img
            src={view_icon}
            alt=""
            className="mx-2 edit-btn "
            onClick={() => setOpen(value)}
          />
        );
      },
    },
  ];

  useEffect(() => {
    fetchData(searchVal);
  }, [page, searchVal]);
  return (
    <div className="dashRightView home_section m-3">
      <div className="d-flex ac-jb mt-2 ">
        <div className="d-flex">
          <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  mb-0 ">
            Total Count :
          </h4>
          <h4 className="f2 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mb-0 ms-2">
            {pagination?.total ?? 0}
          </h4>
        </div>
        <div className="d-flex">
          <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  me-3 mt-1 ms-3">
            Search
          </h4>
          <input
            type="text"
            className="input-pop ps-2"
            placeholder=" Search"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>
      </div>

      {open && (
        <div className="img-popup-design-new" onClick={() => setOpen("")}>
          <div className="img-popup-new position-relative">
            <button
              className="btn btn-light rounded-circle shadow position-absolute"
              style={{
                top: "-15px",
                right: "-15px",
                width: "40px",
                height: "40px",
                zIndex: 1000,
              }}
              onClick={() => setOpen(null)}
            >
              <i className="bi bi-x-lg"></i>
            </button>

            <img
              src={open}
              alt="Preview"
              style={{
                height: "400px",
                width: "400px",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      )}
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={true}
      />
    </div>
  );
};

export default TrainingList;
